<script>

</script>

<style lang="less" global>
    @import "policy.less";

</style>

<div id="content">

    <div class="text">
        <h1>Политика конфиденциальности</h1>
        <p>
            Мы получаем, собираем и храним любую информацию, которую вы вводите на нашем сайте или предоставляете нам любым другим способом. Кроме того, мы храним ID страницы пользователя ВКонтакте, авторизованного на нашем сайте.
        </p>
        <p>
            Когда вы авторизуетесь на нашем сайте через свою страницу ВКонтакте, мы получаем ID страницы и временный токен предоставляющий доступ к открытой информации на странице (имя, фамилия, ID страницы, фотография профиля и т.д.). Временный токен хранится в файлах cookie пользователя и больше нигде.
        </p>

        <p>
            Мы собираем персональные данные и информацию неличного характера для следующих целей:
        </p>
      
        <ol style="padding-left: 80px;">
            <li>
                Для идентификации пользователя на сайте;
            </li>
            <li>
                Для идентификации команды на турнире;
            </li>
            <li>
                Для идентификации участников турнира.
            </li>
        </ol>

        
        <p>
            Информация, предоставленная пользователем обрабатывается администраторами сайта: И. В. Толстовым <a href="https://vk.com/id522095547"><u>https://vk.com/id522095547</u></a> и В. А. Погосяном <a href="https://vk.com/id322053088"><u>https://vk.com/id322053088</u></a>.
        </p>
        <p>
            Если вы больше не хотите, чтобы мы обрабатывали ваши данные, напишите нам по адресу vahepog.vahe@mail.ru.
        </p>

    </div>
    <div class="logo">
        <img class="logo-svg" src="/src/Logo.svg" alt="" />
        <div class="logo-rectangle"></div>
        <div class="logo-text">
            <span>Российское</span>
            <span>Киберспортивное</span>
            <span>Объединение</span>
        </div>
    </div>
</div>
